export const convertNumberSpaces = number => {
	return String(number).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
};

export const convertPhone = number => {
	if (number === undefined) return 'Загрузка';
	return '+' + convertNumberSpaces(number.slice(0,4)) + convertNumberSpaces(number.slice(-7));
};